// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 939) return "static/chunks/939-8f7a9f134ea5648e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"1167":"1ba4b8cd48d8d145","2937":"5e6f1007026be5ab","5279":"dcb0c7c8332a7f56","7229":"ef905d2196dd9daa"}[chunkId] + ".js";
};